import { render, staticRenderFns } from "./addDoc.vue?vue&type=template&id=40ecfb5e"
import script from "./addDoc.vue?vue&type=script&lang=js"
export * from "./addDoc.vue?vue&type=script&lang=js"
import style0 from "./addDoc.vue?vue&type=style&index=0&id=40ecfb5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports